// export default "https://testback.avaex.ir";

export default "https://back.avaex.ir";

// export default "http://192.168.1.110:8000";

// export default "http://127.0.0.1:8000";
